import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {ISimilarProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import actions from '@state/actions';
import { IBrandImage, IBrandLogo } from '@state/brandsImages/types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { storageAccountName, containerNameBrands, containerName } from '@storage/azure-storage-blob';
import Loading from '@components/Loading';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import Swipeable from '@components/Swipeable';
import Button from '@components/Button';
import  { ViewAllIcon }  from '@assets/icons/viewAllIcon';
import { LeftArrowIcon } from '@assets/icons/leftArrow';

const uuid = require('react-uuid');

const SimilarLogos:React.FC<ISimilarProps> = (props) => {
  const authContext = useContext(AuthContext);
  let context = useContext(Context);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);  
  const [logos, setLogos] = useState<IBrandLogo[]>([]);  

  const [brandLogo, setBrandLogo] = useState<IBrandLogo|undefined>(undefined);
  const [viewAll, setViewAll] = useState(false);  
  const [images, setImages] = useState<IBrandImage[]>([]);  
  const [viewImages, setViewImages] = useState<IBrandImage[]>([]);  

 
  const [page, setPage] = useState<number>(0);
  const pageSize =15;
  const itemsLength = 5;
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
   let { editorStatus, data,selectDescribe, onCommandChange} = useContext(Context);

  const dispatch = useDispatch();
    
    const cleanStates=()=>
    {
        setIsLoading(false)
        setLogos([])                
    }


   
    useEffect(() => {    
        
        cleanStates();      
                                  
        if (props.attributes)
        {
            if (props.oemType?.toUpperCase().includes("EVENT"))
            {
              if (props.oem)
              {
                let logo : IBrandLogo = {
                  id: props.oem??"",
                  name: props.oemName??"",
                  logotype: "Event",
                  images: []
                }
              
                
                setViewAll(true)
                setBrandLogo(logo);    
                getImages(logo,0);
              }
              else
              {
                getLogos("Event");        
              }
            }
            else
              getLogos();        
        }                
    }, [props.attributes]);

    async function getLogos(logotype?:string){      
      setIsLoading(true)
      const data: any = await fetchLogos(logotype)         
      if (data) setLogos(data);  
    }

    async function getImages(brandLogo:IBrandLogo, start:number){      
      setIsLoading(true)      
      const data: any = await fetchImages(brandLogo.id,brandLogo.logotype??"",start,pageSize)         
      if (data) setImages(data);   
      
    }

    useEffect(() => {        
         
 
      if (images.length>0 )
      {                       
        let newarray = [...viewImages, ...images];            
        setViewImages(newarray);
      }
      
    },[images])

 

    const fetchLogos = (logotype?:string) => {    
      setIsLoading(true)    
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandsLogos(props.oem, logotype??"", (result, error) => {                
          setIsLoading(false)        
          if (error) reject(error)
          else {                 
            resolve(result)}
  
        }))
      });
    }
    const fetchImages = (brandId:string, type:string, start:number, length:number) => {    
      setIsLoading(true)    
      let query = `c.imageType='LOGOS' and c.status='ACTIVE'`;      
      if (brandId!="" && brandId!= undefined) query += ` and c.brandId='${brandId}'`;
      if (type!="" && type != undefined) query+= ` and EXISTS (SELECT VALUE a FROM a IN c.types WHERE a['value'] = '${type}' and a.id = 'type')`
      //if (type!="" && type != undefined) query+= ` and c.types[0] = { 'id': 'type','value': '${type}'}`
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandImages(query, start,length, undefined, (result, error) => {                
          setIsLoading(false)        
          if (error) reject(error)
          else {                      
            resolve(result)}
  
        }))
      });
    }



  const getImageSrc = (data:IBrandImage)=>{
    
    if (data.id=="" || data.id== undefined)
      return data.srcImage;
    else
    {      
      return `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}` + "TN";
    }
  }


  const renderLoaderContainer = () => {
    if (isLoading)
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
  }


  const handleViewAll = (logo:IBrandLogo) => {
    setViewAll(true)
    setBrandLogo(logo);    
    getImages(logo,0);
  }

  const handleScroll = async(e: any) => {
    
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    
      if (bottom)
      {
        if (brandLogo)
        {
          getImages(brandLogo, (page + pageSize));         
          setPage(page+pageSize); 
        }
        
      }
  }



  return (
    <>
                        
        {
          viewAll?
          <S.ViewAllContainer>
            <S.ViewAll   onClick={(e?:any)=>{         
                    setViewImages([]);
                    setImages([])
                    setPage(0); 
                    setViewAll(false);                    
                  }}>
              {
                !(props.oemType?.toUpperCase().includes("EVENT") && props.oem) &&
                <>
                <LeftArrowIcon></LeftArrowIcon>
                <S.ViewAllText>LIST</S.ViewAllText>
              </>
              }
            </S.ViewAll>
            <S.LogoTitle>{brandLogo?.name} {brandLogo?.logotype??""} Logos </S.LogoTitle>
            <S.LogosContainer onScroll={handleScroll}>
            <S.LogosWrap flex={true}>
            <TransitionGroup className="group-list" id="design-list">
                  {
                    viewImages && viewImages.length > 0 &&
                    viewImages.map((data: any, index: number) => {
                      return (
                        <CSSTransition key={index} timeout={600} classNames="item">
                          <div>
                            <S.LogoContainer selected={index==selectedIndex}>
                              <S.ImgContainer height={86} src={getImageSrc(data)} onClick={()=>{setSelectedIndex(index); props.onSelect(data)}}  transparent={true}/>                              
                            </S.LogoContainer>
                          
                          </div>
                        </CSSTransition>
                      )
                    })
                  }
                </TransitionGroup>              
            </S.LogosWrap>
            </S.LogosContainer>
          </S.ViewAllContainer>
          :
          (logos && logos.length > 0) || isLoading ?
          <S.SlidersContainer>
            
            {
              logos.map((logo:any, i:number) =>{
                return(
                  <>
                <S.LogoTitleContainer>
                  <S.LogoTitle>{ props.oem?(logo.logotype?logo.logotype:logo.logoname):`${logo.name} ${logo.logotype??""}`}</S.LogoTitle>
                  {
                    //logo.images.length>3 &&
                    <S.ViewAll  
                    style={{
                      marginLeft:`auto`,
                      marginRight:`8px`,
                      marginBottom:`3px`
                    }}
                     onClick={(e?:any)=>{                    
                      handleViewAll(logo);    
                    }}>
                      
                      <S.ViewAllText>VIEW ALL</S.ViewAllText>
                  </S.ViewAll>
          
                  }
                </S.LogoTitleContainer>
                <S.SwipeableContainer>
                <Swipeable
                  itemsLength={itemsLength}
                  itemWidth={90}
                  topArrows={30}                 
                  itemsCount={logo.images.length}   
                  itemsShow={2}
                  id={`logos${i}`}
                >
                  <TransitionGroup className="group-list">
                    { logo.images.map((data: any, index: number) => {
                        return (
                          <CSSTransition key={data.id} timeout={600} classNames="item">
                            <S.ItemContainer 
                            id={`preview-component-${index}-logos${i}`}
                            selected={index==selectedIndex}>
                              <S.ImgContainer height={86} src={getImageSrc(data)} onClick={()=>{setSelectedIndex(index); props.onSelect(data)}}  transparent={true}/>                                                              
                            </S.ItemContainer>
                          </CSSTransition>
                        )
                      })
                    }
                    {
                      logo.images.length>=itemsLength &&
                      <S.ViewAll onClick={(e?:any)=>{                    
                        handleViewAll(logo);    
                      }}>
                          <ViewAllIcon></ViewAllIcon>
                      </S.ViewAll>
                      
                    }
                  </TransitionGroup>
                </Swipeable>
                </S.SwipeableContainer>
                </>
                )
            })
            }
          {
            renderLoaderContainer()
          }

          </S.SlidersContainer>
          
          :
          <S.EmptyContainer>
          <p >There are no similar images available for this logo.</p>               
          <p>Search for vehicle images in the Brand Library by clicking the button above and providing the year, make, model, and trim that you're looking for</p>
          </S.EmptyContainer>
        }
        
        </>
  );
}

export default SimilarLogos